module.exports = __webpack_public_path__ + "media/images/map_icons/Basketball-2e69aa848991e70428acc32e03ed13f7.svg";